module.exports = __webpack_public_path__ + "img/bg-1.56b67550.png";